import { createContext } from "react";

export default createContext<{
  resizedColumnId: string | null;
  startResize: (resizedColumnId: string | null) => void;
}>({
  resizedColumnId: null,
  startResize: () => void 0,
});
